import { genUUID, getCategoriesList, getCategory, setCategory, delCategory } from "../repositories/dataRetrieve";
import { Category, Edit, Delete, Save, Add } from "@mui/icons-material";
import { SnackBarMessage} from "../components/index";
import { useState, useEffect } from "react";
import { Offcanvas } from "react-bootstrap";
import { useFormik } from "formik";
import { CircularProgress,
        TableContainer,
        InputLabel,
        Typography,
        IconButton,
        TableBody,
        TableHead,
        TableCell,
        TextField,
        TableRow,
        Backdrop,
        Button,
        Stack,
        Table,
        Paper,
        Grid } from "@mui/material";
import * as Yup from "yup";

const AddPhysicalState = ({ showOffCanvas, handleCloseOffCanvas }) => {
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [snackSeverity, setSnackSeverity] = useState("success");
    const [listCategories, setListCategories] = useState([]);
    const [hideDuration, setHideDuration] = useState(1000);
	const [snackMessage, setSnackMessage] = useState("");
	const [snackOpen, setSnackOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [edit, setEdit] = useState(false);

    const formik = useFormik({
        initialValues: {
            uuid: "",
            descripcion: ""
        },
        validateOnBlur: false,
        validateOnChange: false,
        validationSchema: Yup.object().shape({
            uuid: Yup.string().optional(),
            descripcion: Yup.string().required("Debe ingresar una descripción.")
        }),
        onSubmit: async (values) => {
            setLoading(true);
            const dt = {
                'uuid': selectedCategory,
                'descripcion': values.descripcion
            };

            setCategory(dt).then((rsp) => {
                setHideDuration(1000);
                setSnackSeverity("success");
                setSnackMessage("Se guardó la categoría con éxito.");
                setSnackOpen(true);
                handleNew();
            }).catch((err) => {
                setHideDuration(1500);
                setSnackSeverity("error");
                setSnackMessage(`Ocurrió un error con el guardado de la categoría. Error: ${err}`);
                setSnackOpen(true);
                handleNew();
            });
        },
    });

    const getCategories = async () => {
        try {
        	const result = await getCategoriesList();

        	if (result?.message.toUpperCase() === 'OK') {
        		setListCategories(result?.data);
        	} else {
        		setListCategories([]);
        	}
        } catch (error) {
            setSnackSeverity("error");
            setSnackMessage(`Error en la recuperación de la lista de categorías. Error: ${error}`);
            setSnackOpen(true);
        }
    };

    const handleNew = () => {
        formik.handleReset();
        getCategories();
        setSelectedCategory(genUUID());
        setEdit(false);
        setLoading(false);
    };

    const handleEdit = async (pk) => {
        if (pk) {
            try {
                const result = await getCategory(pk);

                if (result?.message.toUpperCase() === 'OK') {
                    formik.setValues({
                        uuid: result?.data?.uuid || "",
                        descripcion: result?.data?.descripcion || "",
                    });
                    setEdit(true);
                    setSelectedCategory(result?.data?.uuid);
                };
            } catch (error) {
                setSnackSeverity("error");
                setSnackMessage(`Error en la recuperación de la categoría seleccionada. Error: ${error}`);
                setSnackOpen(true);
            };
        };
    };

    const handleDelete = async (pk) => {
        if (pk) {
            try {
                setLoading(true);
                const result = await delCategory(pk);

                if (result?.message.toUpperCase() === 'OK') {
                    setHideDuration(1000);
                    setSnackSeverity("success");
                    setSnackMessage("Se eliminó la categoría con éxito.");
                    setSnackOpen(true);
                    handleNew();
                };
            } catch (error) {
                setSnackSeverity("error");
                setSnackMessage(`Error en la eliminación de la categoría seleccionada. Error: ${error}`);
                setSnackOpen(true);
            };
        };
    };

    const handleBlur = (field) => {
        formik.setFieldTouched(field, true, true);
    };

    useEffect(() => {
        handleNew();
    }, []);

    return (
        <Offcanvas
            placement="end"
            show={showOffCanvas}
            backdrop="true"
            onHide={() => {
                formik.handleReset();
                handleCloseOffCanvas();
            }}
            style={{
                borderTopLeftRadius: "10px",
                top: "15%",
                height: "85%",
            }}
            className="resp-offCanvas"
        >
            <Offcanvas.Header closeButton>
                <Grid container sx={{ pt: "25px", px: "16px" }}>
                    <Grid item md={9} xs={8} sx={{ display: "flex", alignItems: "center" }}>
                        <Category className="me-1" fontSize="large" color='warning' />
                        <Typography variant="h5" id="text-modal-header" sx={{ marginLeft: '1rem', display: { xs: 'none', md: 'flex' } }}>Catalogo de categorias</Typography>
                        <Typography variant="h6" id="text-modal-header" sx={{ marginLeft: '1rem', display: { xs: 'flex', md: 'none' } }}>Catalogo de categorias</Typography>
                    </Grid>
                    <Grid item md={3} xs={4} sx={{ textAlign: "right", display: 'flex', alignSelf: 'center' }}>
                        <InputLabel id="text-input-label">(*) Obligatorio</InputLabel>
                    </Grid>
                </Grid>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <Grid
                    item
                    xs={12}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '2rem'
                    }}
                >
                    <Paper sx={{ width: '80%' }} elevation={0}>
                        <TableContainer component={Paper}>
                            <Table stickyHeader sx={{ overflowY: 'auto' }}>
                                <TableHead>
                                    <TableRow key="head-cell">
                                        <TableCell align="center">#</TableCell>
                                        <TableCell align="center">Descripción</TableCell>
                                        <TableCell align="center">Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {listCategories.map((row, index) => (
                                        <TableRow key={row.uuid}>
                                            <TableCell component="th" scope="row" align="center"> {index + 1} </TableCell>
                                            <TableCell align="left">{row.descripcion}</TableCell>
                                            <TableCell align="center">
                                                <Stack direction="row" spacing={1} sx={{ display: 'flex', justifySelf: 'center' }}>
                                                    <IconButton aria-label="edit" size="small" onClick={() => handleEdit(row.uuid)} >
                                                        <Edit fontSize="inherit" color="info" />
                                                    </IconButton>
                                                    <IconButton aria-label="delete" size="small" onClick={() => handleDelete(row.uuid)} >
                                                        <Delete fontSize="inherit" color="error" />
                                                    </IconButton>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grid>

                <Grid container justifyContent="space-between" columnSpacing="10px" sx={{ px: "16px", width: '80%', justifySelf: 'center' }}>
                    {edit ?
                        <Grid item xs={12} id="uuid-group" sx={{ mt: "4px", mb: "2px" }}>
                            <InputLabel id="text-input-label">ID</InputLabel>
                            <TextField
                                name="uuid"
                                size="small"
                                disabled
                                sx={{ width: "100%" }}
                                value={formik.values.uuid}
                            />
                        </Grid>
                    :
                        null
                    }
                    <Grid item xs={12} id="descripcion-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Descripción *</InputLabel>
                        <TextField
                            name="descripcion"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.descripcion}
                            onChange={formik.handleChange}
                            error={formik.errors.descripcion}
                            onBlur={() => handleBlur("descripcion")}
                        />
                    </Grid>
                    <Grid item xs={12} mt={2} sx={{ display: "flex", justifyContent: "center" }}>
                        <Stack
                            direction="row"
                            spacing={1}
                            justifyContent='end'
                            sx={{
                                maxHeight: '2rem',
                                display: 'flex',
                                alignSelf: 'center'
                            }}
                        >
                            <Button key="btn-save" disabled={loading} variant="contained" size="small" color="success" startIcon={<Save />} onClick={() => formik.handleSubmit()}>
                                Guardar
                            </Button>
                            {edit ?
                                <Button key="btn-new" disabled={loading} variant="contained" size="small" color="info" startIcon={<Add />} onClick={() => handleNew()}>
                                    Nuevo
                                </Button>
                            :
                                null
                            }
                        </Stack>
                    </Grid>

                    <Backdrop
                        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
                        open={loading}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                </Grid>
                <SnackBarMessage
                    severity={snackSeverity}
                    message={snackMessage}
                    open={snackOpen}
                    onClose={() => setSnackOpen(false)}
                    hideDuration={hideDuration}
                />
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default AddPhysicalState;
